import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  register: () => void;
  isLogged?: boolean;
}

const AnalizeProjectsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="tab-content padding-40">
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>
            Accede a las mejores oportunidades de inversión
          </strong>
        </p>
        <div className="gap-20"/>
        <p>
          The Crowd Angel, a través de sus socios (Inveready, Keyword VC y Sevenzonic) así como del contacto directo en
          las mejores incubadoras, aceleradoras y venture builders nacionales, tiene acceso a gran parte de las
          operaciones de financiación que se presentan en España. Todas las empresas publicadas han pasado un riguroso
          proceso de selección y análisis, y sólo se presentan aquellas con un alto potencial de crecimiento
          (aproximadamente el 2% de todas las que recibimos).
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '394px', height: '197px'}}
          alt="oportunidades de inversion"
          src="/img/02_accede_mejores_oportunidades.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6 text-center">
        <img
          style={{width: '520px', height: '260px'}}
          alt="analiza informacion"
          src="/img/03_analiza_informacion.png"
        />
      </div>
      <div className="col-sm-6">
        <p>
          <strong>
            Analiza la información de las empresas
          </strong>
        </p>
        <div className="gap-20"/>
        <p>

          Para cada operación, tendrás a tu disposición un Plan de Negocio detallado con toda la información necesaria
          para que puedas analizar la empresa y tomar la decisión de inversión.
        </p>
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>
            Expón tus opiniones
          </strong>
        </p>
        <div className="gap-20"/>
        <p>
          Una vez analizada la documentación, The Crowd Angel te permite intercambiar opiniones con otros inversores y
          con el equipo emprendedor a través del canal de comentarios en la ficha de la operación.
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '520px', height: '260px'}}
          alt="comentarios"
          src="/img/04_comentarios.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <p className="text-center">
      {props.isLogged ?
        <Link to={'/invertir'}>
          <button className="btn btn-secondary btn-lg">
              Invertir
          </button>
        </Link> :
        <button
          className="btn btn-secondary btn-lg"
          onClick={() => props.register()}
        >
          Registrarse
        </button>
      }
    </p>
  </div>
);

export default AnalizeProjectsComponent;



// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/AnalizeProjects.component.tsx